import React from "react";

function Button({name, styleClass, onClick, icon}) {
    return <button className={`btn ${styleClass}`} onClick={onClick}>
        {icon}{' '}
        {name}
    </button>
}

export default Button